(() => {
  "use strict";

  const money = (cents, currency = "USD") => {
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency }).format(cents / 100);
    } catch {
      return "$" + (cents / 100).toFixed(2);
    }
  };
  const esc = (s) =>
    String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

  const dialog = document.createElement("dialog");
  dialog.className = "shop-dialog";
  dialog.id = "product-dialog";
  dialog.setAttribute("aria-labelledby", "dialog-title");
  dialog.innerHTML =
    '<div class="dialog-top"><strong id="dialog-title">Your selection</strong><button class="dialog-close" type="button" aria-label="Close">✕</button></div><div class="dialog-body"></div>';
  document.body.append(dialog);
  const body = dialog.querySelector(".dialog-body");
  let previousFocus = null;

  function openDialog(title) {
    if (!dialog.open) previousFocus = document.activeElement;
    document.getElementById("dialog-title").textContent = title;
    if (!dialog.open) dialog.showModal();
  }
  dialog.querySelector(".dialog-close").onclick = () => dialog.close();
  dialog.addEventListener("click", (e) => {
    if (e.target === dialog) {
      const b = dialog.getBoundingClientRect();
      if (e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom) dialog.close();
    }
  });
  dialog.addEventListener("close", () => previousFocus?.focus());

  async function fetchCart() {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    return res.json();
  }
  function updateCount(n) {
    document.querySelectorAll("[data-bag-count]").forEach((el) => {
      el.textContent = String(n);
    });
  }

  async function refreshCount() {
    try {
      const cart = await fetchCart();
      updateCount(cart.item_count);
    } catch (_) {}
  }

  async function addToCart(id, quantity) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) }] }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || "Could not add to bag");
    }
    return res.json();
  }

  async function changeLine(key, quantity) {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: Number(quantity) }),
    });
    return res.json();
  }

  async function loadProduct(handle) {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error("Product not found");
    return res.json();
  }

  function variantForOptions(product, color) {
    if (!color) return product.variants[0];
    return (
      product.variants.find((v) => v.options.map((o) => String(o).toLowerCase()).includes(String(color).toLowerCase())) ||
      product.variants[0]
    );
  }

  async function openProduct(handle) {
    const p = await loadProduct(handle);
    const colors = [...new Set(p.variants.map((v) => v.option1).filter(Boolean))];
    const first = p.variants[0];
    const img = p.featured_image || (first && first.featured_image);
    body.innerHTML = `<div class="dialog-product">
      <img class="dialog-photo" src="${esc(img)}" alt="${esc(p.title)}">
      <div>
        <h2>${esc(p.title)}</h2>
        <p class="dialog-price">${money(p.price)}</p>
        ${
          colors.length
            ? `<label for="option-color">Color</label><select id="option-color">${colors
                .map((c, i) => `<option ${i === 0 ? "selected" : ""}>${esc(c)}</option>`)
                .join("")}</select>`
            : ""
        }
        <label for="option-qty">Quantity</label>
        <input id="option-qty" type="number" min="1" max="20" value="1">
        <button class="dialog-action" type="button" id="add-to-bag">Add to bag</button>
      </div>
    </div>
    <div class="dialog-note">Shipping and tax calculated at checkout. Brand names describe fit only.</div>`;
    const colorSel = body.querySelector("#option-color");
    if (colorSel) {
      colorSel.onchange = () => {
        const v = variantForOptions(p, colorSel.value);
        if (v.featured_image) body.querySelector("img").src = v.featured_image;
      };
    }
    body.querySelector("#add-to-bag").onclick = async () => {
      const qty = Number(body.querySelector("#option-qty").value || 1);
      const color = colorSel ? colorSel.value : null;
      const v = variantForOptions(p, color);
      try {
        await addToCart(v.id, qty);
        await renderBag();
      } catch (err) {
        alert(err.message);
      }
    };
    openDialog("Choose your adapter");
  }

  async function renderBag() {
    const cart = await fetchCart();
    updateCount(cart.item_count);
    if (!cart.items.length) {
      body.innerHTML =
        '<h2>Your bag is empty.</h2><p>Choose an adapter to add it.</p><button class="dialog-action" type="button" id="continue-shopping">Browse adapters</button>';
      body.querySelector("#continue-shopping").onclick = () => dialog.close();
      openDialog("Bag");
      return;
    }
    body.innerHTML =
      cart.items
        .map(
          (x) => `<div class="bag-line">
        <img src="${esc(x.image)}" alt="${esc(x.product_title)}">
        <div>
          <strong>${esc(x.product_title)}</strong>
          <p>${esc(x.variant_title || "")} · ${money(x.final_price)} each</p>
          <label>Quantity</label>
          <input data-key="${esc(x.key)}" type="number" min="0" max="99" value="${x.quantity}">
          <button class="dialog-link" type="button" data-remove="${esc(x.key)}">Remove</button>
        </div>
        <strong>${money(x.final_line_price)}</strong>
      </div>`
        )
        .join("") +
      `<div class="bag-total"><span>Item subtotal</span><strong>${money(cart.total_price)}</strong></div>
      <p>Shipping and tax calculated at checkout.</p>
      <a class="dialog-action" href="/checkout" style="text-align:center;text-decoration:none;">Checkout</a>
      <button class="dialog-link" type="button" id="continue-shopping">Continue shopping</button>`;
    body.querySelectorAll("[data-remove]").forEach((b) => {
      b.onclick = async () => {
        await changeLine(b.dataset.remove, 0);
        await renderBag();
      };
    });
    body.querySelectorAll("input[data-key]").forEach((input) => {
      input.onchange = async () => {
        await changeLine(input.dataset.key, input.value);
        await renderBag();
      };
    });
    body.querySelector("#continue-shopping").onclick = () => dialog.close();
    openDialog("Bag");
  }

  document.querySelectorAll("[data-product-handle]").forEach((b) => {
    b.addEventListener("click", (e) => {
      e.preventDefault();
      openProduct(b.dataset.productHandle).catch((err) => alert(err.message));
    });
  });
  document.querySelectorAll("[data-bag]").forEach((b) => {
    b.addEventListener("click", (e) => {
      e.preventDefault();
      renderBag().catch(() => {
        window.location.href = "/cart";
      });
    });
  });
  document.querySelectorAll(".color-buttons [data-color]").forEach((b) => {
    b.addEventListener("click", () => {
      const card = b.closest("[data-card]");
      card?.querySelectorAll("[data-color]").forEach((x) => x.setAttribute("aria-pressed", String(x === b)));
      const img = card?.querySelector("[data-product-image]");
      if (img && b.dataset.image) img.src = b.dataset.image;
      const label = card?.querySelector("[data-color-name]");
      if (label) label.textContent = b.dataset.color;
    });
  });

  const menu = document.getElementById("menu-btn");
  const mobile = document.getElementById("mobile");
  if (menu && mobile) {
    menu.onclick = () => {
      const on = mobile.classList.toggle("open");
      menu.setAttribute("aria-expanded", String(on));
    };
    mobile.querySelectorAll("a").forEach((a) => {
      a.onclick = () => {
        mobile.classList.remove("open");
        menu.setAttribute("aria-expanded", "false");
      };
    });
  }

  document.querySelectorAll("[data-fit-form]").forEach((form) => {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      if (!form.reportValidity()) return;
      const tool = form.querySelector("[name=tool]").value;
      const hose = form.querySelector("[name=hose]").value;
      const id =
        tool === "adapter-125" && hose === "125"
          ? "adapter-125"
          : tool === "adapter-d27" && hose === "1875"
            ? "adapter-d27"
            : null;
      const out = form.querySelector(".fit-result");
      const card = id ? document.querySelector(`[data-fit-id="${id}"]`) : null;
      if (card) {
        const title = card.querySelector("h3")?.innerText || "Suggested adapter";
        out.innerHTML = `<strong>Suggested option: ${esc(title)}</strong><p>Check the listed model and connector photos before ordering.</p><button type="button" class="button fit-action">View adapter</button>`;
        out.querySelector("button").onclick = () => card.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        out.innerHTML =
          "<strong>Fit needs a closer check.</strong><p>These two adapters do not establish a match for that combination. Confirm your tool model and both connector ends before buying.</p>";
      }
    });
  });

  refreshCount();
})();
